import apiClient from "./apiClient";
import { Order, OrdersApiResponse, OrderDetailApiResponse } from "../types/order";
import { toLegacyListResponse } from "../utils/normalizePaginatedResponse";

const ORDERS_PATH = "shopforme";

export const getOrders = async (
  page = 1,
  limit = 10,
  search = "",       // New
  status = ""        // New
): Promise<OrdersApiResponse> => {
  try {
    const params: any = { page, limit };
    if (search) params.search = search;
    if (status) params.status = status;

    const response = await apiClient.get(ORDERS_PATH, { params });
    return toLegacyListResponse<Order, "allOrders">(response.data, "allOrders");
  } catch (error) {
    console.error("Failed to fetch purchase orders:", error);
    throw error;
  }
};

export const getOrderById = async (orderId: string): Promise<OrderDetailApiResponse> => {
  try {
    const response = await apiClient.get<OrderDetailApiResponse>(`${ORDERS_PATH}/${orderId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch details for order ID ${orderId}:`, error);
    throw error;
  }
};

export const updateOrderStatus = async (shopId: string, newStatus: string): Promise<void> => {
  try {
    await apiClient.patch(`${ORDERS_PATH}/update-status`, { shopId, newStatus });
  } catch (error) {
    console.error(`Failed to update status for order ID ${shopId}:`, error);
    throw error;
  }
};

export const updateCartItemPrice = async (
  itemId: string,
  amount: number
): Promise<void> => {
  try {
    await apiClient.patch(`${ORDERS_PATH}/item/${itemId}/price`, { amount });
  } catch (error) {
    console.error(`Failed to update price for item ID ${itemId}:`, error);
    throw error;
  }
};